import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { ErrorsHostDirective } from '@app/core/forms/directives/errors-host.directive';
import { IfInvalidDirective } from '@app/core/forms/directives/if-invalid.directive';
import { UploadFileReqDto } from '@app/entities/files/interfaces/upload-file.req.dto';
import { UserProfile } from '@app/entities/users/interfaces/user-profile';
import { ProfileSelectors, UploadAvatar } from '@app/store';
import { Store } from '@ngxs/store';
import { map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-account-avatar',
  templateUrl: './account-avatar.component.html',
  styleUrls: ['./account-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, IfInvalidDirective, ErrorsHostDirective],
})
export class AccountAvatarComponent implements OnInit {
  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {}

  protected profile$: Observable<UserProfile | undefined> = this.store.select(
    ProfileSelectors.profile,
  );

  fc = new FormControl<number | null>(null);

  protected avatarUrl$!: Observable<string | null | undefined>;

  @ViewChild('fileEl')
  fileEl!: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.initAvatar();
    this.populateForm();
  }

  private initAvatar(): void {
    this.avatarUrl$ = this.profile$.pipe(
      map((value: UserProfile | undefined) => {
        return value?.avatar?.url;
      }),
    );
  }

  private populateForm(): void {
    this.profile$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((userProfile: UserProfile | undefined) => {
          this.fc.setValue(userProfile?.avatar?.id || null);
        }),
      )
      .subscribe();
  }

  protected onSelectFile(e: any): void {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const requestData: UploadFileReqDto = {
        image: reader.result as string,
        name: file.name,
      };
      this.fileEl.nativeElement.value = '';
      this.store.dispatch(new UploadAvatar(requestData));
    };
  }
}
